import React, { useEffect, Suspense } from "react";
import { Route, Redirect, useLocation } from "react-router-dom";
import { isLogin } from "../utils/userLoggedInCheck";
import useQuery from "../utils/_hooks/useQuery";
import Loader from "../library/Loader";
import useRemoteConfig from "../utils/_hooks/useRemoteConfig";

const tags = {
    useradd: {
        tag: "useradd",
        pathname: "/account/users",
    },
    "update-address": {
        tag: "update-address",
        pathname: "/update-user-address",
    },
};

const PublicRoute = ({ component: Component, ...rest }) => {
    const { pathname } = useLocation();
    const r = useQuery();

    const isLoginPath = pathname === "/login";
    const redirectTag = r.get("r");
    const { featureConfig } = useRemoteConfig();

    useEffect(() => {
        const { ngn } = featureConfig;
        if (ngn?.freshdesk?.available && window.fcWidget) {
            window.fcWidget.init({
                token: "06d6351e-b8cb-4050-8e8f-eb4dc286b7c2",
                host: "https://wchat.freshchat.com",
                customerType: "Business",
                config: {
                    headerProperty: {
                        backgroundColor: "#000000",
                    },
                },
            });

            return () => {

                window.fcWidget.user.clear()
                window.fcWidget.destroy();
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [featureConfig]);

    if (isLoginPath && redirectTag && tags[redirectTag] && redirectTag === tags[redirectTag].tag) {
        const isUserNotLoggedIn = isLogin() === false;

        return (
            <Route
                {...rest}
                render={(props) =>
                    isUserNotLoggedIn ? (
                       <Component {...props} redirectPath={tags[redirectTag].pathname} />
                    ) : (
                        <Redirect
                            to={{
                                pathname: tags[redirectTag].pathname,
                            }}
                        />
                    )
                }
            />
        );
    }

    return (
        <Route
            {...rest}
            render={(props) =>
                isLogin() === false ? (
                    <Suspense fallback={<Loader />}>
                        <Component {...props} />
                    </Suspense>
                ) : (
                    <Redirect
                        to={{
                            pathname: "/home",
                        }}
                    />
                )
            }
        />
    );
};

export default PublicRoute;
